import React from "react";

import { motion } from "framer-motion/dist/framer-motion";

import "./DataFieldsButton.css";
import { ReactComponent as EditIconDF } from "../../../../assets/images/environment/EditIconDF.svg";

export default function DataFieldsButton(props) {
  const { toggleDataFieldsModal, showDataFieldsModal, inToolbar } = props;
  const buttonClass = showDataFieldsModal ? "DataFieldsButtonActive" : "DataFieldsButton";
  return (
    <motion.div layout transition={{ duration: 0.2 }} className={`${buttonClass}${inToolbar ? " DataFieldsButton--toolbar" : ""}`} onClick={() => toggleDataFieldsModal()}>
      <EditIconDF className="DataFieldsIcon" aria-hidden />
      <span className="DataFieldsLabel">Data Fields</span>
    </motion.div>
  );
}
